/* eslint-disable-next-line */
export const getUserRights = ({ loggedUserRights: { roles } }) => {
  return roles;
};
